// Define banner dimensions constants
export const BANNER_DIMENSIONS = {
  DESKTOP: '1280x600',
  TABLET: '1170x400',
  MOBILE: '360x390',
};

// Define device type enum
export enum DeviceType {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

// Define form data interface for banners
export interface BannerFormData {
  imageUrl?: string;
  mobileImageUrl?: string;
  tabletImageUrl?: string;
  title: string;
  description: string;
  location: string;
  linkUrl: string;
  active?: boolean;
  fromDate: Date;
  toDate: Date;
}

// Define upload data interface extending form data
export interface BannerUploadData extends BannerFormData {
  imageFiles: {
    [DeviceType.DESKTOP]?: File | undefined;
    [DeviceType.TABLET]?: File | undefined;
    [DeviceType.MOBILE]?: File | undefined;
  };
}

// Helper functions for device type detection
export const detectDeviceTypeFromFilename = (filename: string): DeviceType => {
  // Extract dimensions from filename (like _1280x600)
  const match = filename.match(/_(\d+x\d+)/i);

  if (match && match[1]) {
    const dimensions = match[1];

    // Check the exact dimensions we support
    if (dimensions === BANNER_DIMENSIONS.DESKTOP) {
      return DeviceType.DESKTOP;
    }
    if (dimensions === BANNER_DIMENSIONS.TABLET) {
      return DeviceType.TABLET;
    }
    if (dimensions === BANNER_DIMENSIONS.MOBILE) {
      return DeviceType.MOBILE;
    }
  }

  // Default to desktop if no specific pattern is found
  console.log(`Could not detect device type for ${filename}, defaulting to desktop`);
  return DeviceType.DESKTOP;
};

// Helper to detect device type from dimensions
export const detectDeviceTypeFromDimensions = async (): Promise<DeviceType> => {
  try {
    // Just default to desktop since we're focusing on filename patterns
    return DeviceType.DESKTOP;
  } catch (err) {
    console.error('Error detecting image dimensions:', err);
    return DeviceType.DESKTOP;
  }
};
